// Module
var code = "<simple-list-layout title-label-code=\"'accesses.keychains'\" new-entity-label-code=\"'accesses.keychain.new'\" entities=\"accessKeyChains\" columns=\"columns\"></simple-list-layout> ";
// Exports
export default code;